import { TagType, FilterType, Filter, FilterKey } from 'types';
import { IGetFilterGroupsProps } from '../../types';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { UserRole } from '@/store/auth/types';

const studentsEmptyTagId = 'None';

const parseTags = (tags: Array<{ label: string; value: string }>) => {
  const allTagOptions: { label: string; value: string }[] = [];

  tags.forEach((tag: { label: string; value: string }) => {
    if (tag?.label && Object.keys(tag?.label).length) {
      allTagOptions.push({
        label: tag?.label,
        value: tag?.value,
      });
    }
  });

  const options = [
    ...allTagOptions,
    {
      label: 'None',
      value: studentsEmptyTagId,
    },
  ];

  return options;
};

const key = FilterKey.PROGRAMMABLE_TAGS;
export const getProgrammableTagsFilter = ({
  activeFilters,
  userRole,
  filterOptions,
}: IGetFilterGroupsProps): Filter | null => {
  const canFilterTagsStatus = hasPerm(userRole || UserRole.Unknown, P.FILTER_PROG_TAGS);
  const programmaticTagsFilterOptions = (filterOptions?.tag || []).filter(
    t => t.type && t.type === TagType.PROGRAMMABLE,
  );
  if (!canFilterTagsStatus) {
    return null;
  }
  const allProgrammableTags = parseTags(programmaticTagsFilterOptions || []);

  const filters = activeFilters[key] ?? [];
  const options = allProgrammableTags.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });
  return {
    name: 'Programmable tags',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: options,
    },
  };
};
